import React, { Component } from 'react';
import UprinceNavigation from '../../shared/uprinceNavigation/cuProjectNavigation/component';
import StandardMailMainLayout from './standardMailMainLayout';
import { getContractingUnit } from '../../shared/util';


interface Props {
  currentUser: any
}

interface State {
  isContractUnit: boolean;
  isProject: boolean;
}

export class StandardMail extends Component<Props, State> {
  render() {
    return (
      <UprinceNavigation
        currentUser={this.props.currentUser}
        selectedNavigationIndex={`/CU/${getContractingUnit()}/standard-mail`}
      >
        <StandardMailMainLayout/>
      </UprinceNavigation>
    );
  }
}

export default (StandardMail);
